import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';

interface TableItem {
  name: string;
  url: string;
}

interface WeappItem {
  appid: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'nfc',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const loading = ref(false);
const tableData = ref<TableItem[]>([]);
const currentStoreId = ref<number>(0);

const loadData = async() => {
  try {
    loading.value = true;
    tableData.value = [];

    // 获取小程序列表
    const weappRes = await useApi().weappApi.listWeappweapp({
      conditions: {},
    });
    const weappList = (weappRes.data.data || []) as WeappItem[];

    // 获取每个小程序的NFC URL
    for (const weapp of weappList) {
      try {
        const urlRes = await useApi().storeApi.getNFCUrlstore({
          appid: weapp.appid,
          storeId: currentStoreId.value,
        });

        tableData.value.push({
          name: weapp.name,
          url: urlRes.data.data || '-',
        });
      } catch (error) {
        console.error('获取NFC URL失败:', error);
        tableData.value.push({
          name: weapp.name,
          url: '获取失败',
        });
      }
    }
  } catch (error) {
    console.error('加载数据失败:', error);
    ElMessage.error('加载数据失败');
  } finally {
    loading.value = false;
  }
};

const show = async(storeId: number) => {
  visible.value = true;
  currentStoreId.value = storeId;
  await loadData();
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "NFC URL列表",
    width: "800px",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: tableData.value }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "小程序名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "url",
            label: "NFC URL",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})